import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries/typologies/list`, {params: data})
    },
    listAll() {
        return axios.get(`/vhe/auxiliaries/typologies/list/all`)
    },
    find(id) {
        return axios.get(`/vhe/auxiliaries/typologies/find/${id}`)
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/typologies/create`, data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/typologies/update`, data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/typologies/delete/${id}`)
    },
}
